import { useEffect } from 'react';

/**
 * Set `document.title` for the lifetime of the calling component and
 * restore the previous title on unmount. Designed for member-portal pages
 * so the browser tab reads e.g. "Template Library — HR Hub | DriveHR".
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    if (title) document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
